var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
         ("" + _vm.classPrefix),
         _vm.size && (_vm.classPrefix + "--" + _vm.size),
         _vm.noCustomColor && (_vm.classPrefix + "--color-" + _vm.color),
         _vm.ghost && (_vm.classPrefix + "--ghost"),
         _vm.isChecked && 'is-checked'
    ],style:(_vm.customStyle),on:{"click":function($event){$event.stopPropagation();return _vm.handlerClick($event)}}},[_c('span',{class:[(_vm.classPrefix + "__text")]},[_vm._t("default")],2),(_vm.closable)?_c('Icon',{class:[
              (_vm.classPrefix + "__icon")
          ],style:(_vm.iconStyle),attrs:{"type":_vm.iconType},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.handlerClose($event)}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }